var PriceRangeContext = class extends HTMLElement {
    #abortController;
    minPrice = 0;
    async connectedCallback () {
        this.#abortController = new AbortController();
        const rangeLowerBound = this.querySelector('input[type="range"]:first-child'),
            rangeHigherBound = this.querySelector('input[type="range"]:last-child'),
            textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]'),
            textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
        if (textInputLowerBound.value == 0) {
            try {
                const u = new URL(window.location.href);
                u.searchParams.set('view', 'price-range');
                u.searchParams.set('sort_by', 'price-ascending');

                const res = await fetch(u.toString(), { credentials: 'same-origin' });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);

                const text = await res.text();
                const data = JSON.parse(text);
                console.log(data);

                const minPrice = Math.ceil(Number(data?.min_price || 0));
                if (minPrice > 0) {
                    textInputLowerBound.value = minPrice;
                    textInputLowerBound.min = minPrice;
                    rangeLowerBound.value = minPrice;
                    rangeLowerBound.min = minPrice;
                    this.minPrice = minPrice;
                }
            } catch (err) {
                console.warn('[price-range-context] Failed to fetch min price:', err);
            }
        }

        textInputLowerBound.addEventListener("focus", () => textInputLowerBound.select(), { signal: this.#abortController.signal });
        textInputHigherBound.addEventListener("focus", () => textInputHigherBound.select(), { signal: this.#abortController.signal });
        textInputLowerBound.addEventListener(
            "change",
            (event) => {
                event.preventDefault();
                event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1), event.target.min);
                rangeLowerBound.value = event.target.value;
                console.log('rangeLowerBound value:', rangeLowerBound.value);
                console.log('rangeLowerBound max:', rangeLowerBound.max);
                console.log((parseInt(rangeLowerBound.value) / parseInt(rangeLowerBound.max)) * 100);
                rangeLowerBound.parentElement.style.setProperty("--range-min", `${((parseInt(rangeLowerBound.value) - this.minPrice) / (parseInt(rangeLowerBound.max) - this.minPrice)) * 100}%`);
            },
            { signal: this.#abortController.signal },
        );
        textInputHigherBound.addEventListener(
            "change",
            (event) => {
                event.preventDefault();
                event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1), event.target.max);
                rangeHigherBound.value = event.target.value;
                rangeHigherBound.parentElement.style.setProperty("--range-max", `${((parseInt(rangeHigherBound.value) - this.minPrice) / (parseInt(rangeHigherBound.max) - this.minPrice)) * 100}%`);
            },
            { signal: this.#abortController.signal },
        );
        rangeLowerBound.addEventListener(
            "change",
            (event) => {
                event.stopPropagation();
                textInputLowerBound.value = event.target.value;
                textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
            },
            { signal: this.#abortController.signal },
        );
        rangeHigherBound.addEventListener(
            "change",
            (event) => {
                event.stopPropagation();
                textInputHigherBound.value = event.target.value;
                textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
            },
            { signal: this.#abortController.signal },
        );
        rangeLowerBound.addEventListener(
            "input",
            (event) => {
                event.target.value = Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1);
                event.target.parentElement.style.setProperty("--range-min", `${((parseInt(event.target.value) - this.minPrice) / (parseInt(event.target.max) - this.minPrice)) * 100}%`);
                textInputLowerBound.value = event.target.value;
            },
            { signal: this.#abortController.signal },
        );
        rangeHigherBound.addEventListener(
            "input",
            (event) => {
                event.target.value = Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1);
                event.target.parentElement.style.setProperty("--range-max", `${((parseInt(event.target.value) - this.minPrice) / (parseInt(event.target.max) - this.minPrice)) * 100}%`);
                textInputHigherBound.value = event.target.value;
            },
            { signal: this.#abortController.signal },
        );
    }
    disconnectedCallback () {
        this.#abortController.abort();
    }
};
if (!window.customElements.get("price-range-context")) {
    window.customElements.define("price-range-context", PriceRangeContext);
}
